import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants } from 'src/app/core/constants/url.constants';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomLoginService {
  private loginData = new BehaviorSubject(null);
  loginData$ = this.loginData.asObservable();

  getLoginData(value): any {
    this.loginData.next(value);
  }
  private logindata$: BehaviorSubject<any> = new BehaviorSubject(null);
  getRes(): Observable<any> {
    return this.logindata$.asObservable();
  }
  setRes(template: any) {
      this.logindata$.next(template);
  }
  // tslint:disable-next-line:member-ordering
  private userPwd = new BehaviorSubject(null);
  // tslint:disable-next-line:member-ordering
  userPwd$ = this.userPwd.asObservable();

  getUserPwd(value): any {
    this.userPwd.next(value);
  }
  private twoFAType = new BehaviorSubject(null);
  twoFATypeValue = this.twoFAType.asObservable();

  setTwoFAType(twoFAValue){
    this.twoFAType.next(twoFAValue);
  }
  getTwoFAType(){
    return this.twoFATypeValue;
  }
  
  private ASMObject = new BehaviorSubject(null);
  ASMObject$ = this.ASMObject.asObservable();

  setASMObject(data:any){
    this.ASMObject.next(data);
  }
  getASMObject(){
    return this.ASMObject;
  }


  constructor(private httpUtilService: HttpUtilService, private httpClient: HttpClient) { }

  checkUserCredentials(userId , pass,otpMethod,isKeepLoggedIn): any {
    const data = {userid : userId , password : pass,twoFAType:otpMethod,isKeepMeLoggedIn:isKeepLoggedIn};
    return this.httpUtilService.post(Constants.CHECK_USER_CREDENTIALS , data);
    // return this.httpUtilService.post(Constants.loginUser(userId , pass)
    // .CHECK_USER_CREDENTIALS , data);
  }

  validateCode(otp , userId , token, cdcToken): any {
   const body = {code : otp , uid : userId , vtoken : token, cdcToken : cdcToken};
   return this.httpUtilService.postMethodwithResponseType(Constants.VALIDATE_CODE , body );
  //  return this.httpUtilService.post(Constants.validateCode(otp , userId , token)
  //   .VALIDATE_CODE , body );
  }
  getPasswordResetToken(data: any): any {
    const body = data;
    // return this.httpClient.get("/assets/privacypolicy.json").pipe(map((response: any)=>response))
    // return this.httpUtilService.post(Constants.changePasswordToken(body.loginID));
    // return this.httpUtilService.post('https://accounts.au1.gigya.com/accounts.resetPassword',body);
    // return this.httpClient.post('https://accounts.au1.gigya.com/accounts.resetPassword',body);
    return this.httpUtilService.post(Constants.changePasswordToken(body.loginID).CHANGE_PASSWORD_TOKEN, data);
  }

  resendOTP(userId:any, method:any){
    const data = {userid : userId ,twoFAType:method};
    return this.httpUtilService.post(Constants.RESEND_OTP , data);

  }
  GetSMSCountries(){
    return this.httpUtilService.get(Constants.GetSMSCountries());
  }
  getASMAcess(){
    return this.httpUtilService.get(Constants.getASMAccess()); 
  }
  updateBiometricRegistration(enabledornot:boolean,userid:any) {
    
    return this.httpUtilService.put(Constants.updatebiometrics(enabledornot,userid).biometricFlag,null);
  }

}
